<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="true"></app-sub-header>
      <!--end::Container-->
    </div>

    <div class="container-xxl" v-show="!isReady || formLoadData">
      <Loader />
    </div>

    <div v-show="isReady && !formLoadData">
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
          <PurchaseForm :purchase="purchase" @loading-data="val => formLoadData = val" :submit-invoice="isCreated ? submitInvoice : updateInvoice"
            :processSubmitting="processSubmitting" />
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import AppSubHeader from "@/views/SupplierPurchase/Partials/AppSubHeader.vue";
import Loader from "@/components/Loader.vue";
import PurchaseForm from "@/components/Purchase/PurchaseForm.vue";
import { useStore } from "vuex";
import { computed, onMounted, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router"
import { useHasAbility } from "@/composables/hasAbility";

const router = useRouter()
const store = useStore()
const { can } = useHasAbility()
const route = useRoute()
const isCreated = ref(true)

const title = ref("breadcrumbs.purchase.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.purchase.list',
    path: '/admin/suppliers/purchases'
  },
  {
    name: 'breadcrumbs.purchase.edit',
    path: '/admin/suppliers/purchases/edit/:id'
  }
])
const isReady = ref(false)
const processSubmitting = ref(false)
const formLoadData = ref(false)

const today = new Date();
const day = String(today.getDate()).padStart(2, '0');
const month = String(today.getMonth() + 1).padStart(2, '0');
const year = today.getFullYear();
const formattedStartDate = `${day}-${month}-${year}`;

const purchase = ref({
  order_taxes: [],
  order_contents: [{
    product_sale_element_id: "",
    comments: "",
    quantity: 1,
    purchase_price: 0,
    taxes: [],
  }],
  other_fees: [],
  status: 'DRAFT',
  date: formattedStartDate
})

function getTaxIds(taxes) {
  return taxes.map(tax => tax.taxe.id);
}


const purchaseCurrent = computed(() => store.getters['orders/currentOrder'])

watch(() => purchaseCurrent.value, (newValue) => {
  purchase.value.id = newValue.id;
  purchase.value.status = newValue.status;
  purchase.value.supplier_id = newValue.supplier_id;
  purchase.value.currency_id = newValue.currency_id
  purchase.value.date = newValue.date
  purchase.value.delivery_date = newValue.delivery_date
  purchase.value.other_fees = newValue.other_fees.map(fee => ({
    id: [fee.fee.id],
    price: fee.price
  }));

  purchase.value.order_contents = newValue.order_contents.map(content => ({
    product_sale_element_id: content.product_sale_element_id,
    quantity: content.quantity,
    purchase_price: content.purchase_price,
    lot_id: content.lot_id,
    taxes: getTaxIds(content.order_content_taxes),
  }));

  purchase.value.order_taxes = getTaxIds(newValue.order_taxes);
})

const submitInvoice = () => {
  processSubmitting.value = true
  store.dispatch('orders/createOrder', purchase.value)
    .then((response) => {
      window.toastr['success'](i18n.global.t('notification.order_created'))
      router.push({ name: 'suppliers-purchases-view', params: { id: response.data.data.id } })
    })
    .catch(err => {
      processSubmitting.value = false
      window.toastr['error'](i18n.global.t('notification.order_created_error'))
      console.log(err)
    })
  processSubmitting.value = false
}

const updateInvoice = () => {
  processSubmitting.value = true
  store.dispatch('orders/updateOrder', purchase.value)
    .then((response) => {
      window.toastr['success'](i18n.global.t('notification.order_updated'))
      router.push({ name: 'suppliers-purchases-view', params: { id: response.data.data.id } })
    })
    .catch(err => {
      processSubmitting.value = false
      window.toastr['error'](i18n.global.t('notification.order_updated_error'))
      console.log(err)
    })
  processSubmitting.value = false
}

onMounted(() => {
  isReady.value = false
  Promise.all([
    loadData()
  ])
    .then(res => isReady.value = true)
    .catch(err => isReady.value = true)
  isReady.value = true
})

async function loadData() {
  if (route.params.id) {
    isCreated.value = false
    await store.dispatch('orders/getOrderById', route.params.id)
  }
}


</script>

<style scoped></style>